import { darkTheme, whiteTheme } from '../utils';

export enum ThemeTypes {
  DARK = 'dark',
  WHITE = 'white'
}

export type ThemeType = typeof darkTheme | typeof whiteTheme;
